import { z } from '@harvestiq/zod';
import { dbUserSchema, safeDbUserSchema } from './db-user';
import { dbUserRoleSchema } from '../user-roles/db-user-role';

export const unsafeUserSchema = dbUserSchema.extend({
  roles: z.array(dbUserRoleSchema),
});
export type UnsafeUser = z.infer<typeof unsafeUserSchema>;

export const safeUserSchema = safeDbUserSchema.extend({
  roles: z.array(dbUserRoleSchema),
});
export type SafeUser = z.infer<typeof safeUserSchema>;
